import React, { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

export interface SignDocumentProps {
  header: React.ReactNode
  body: React.ReactNode
}

export const SignDocument: FC<SignDocumentProps> = ({ header, body }) => {
  return (
    <div className="content">
      <Container fluid>
        <Row>
          <Col>
            {header}
            {body}
          </Col>
        </Row>
      </Container>
    </div>
  )
}
